<template>
  <el-card shadow="never">
    <el-row style="margin-bottom: 22px">
      <el-input v-model="queryInfo.lendOrderCode" class="input" placeholder="借出单号" clearable></el-input>
      <el-input v-model="queryInfo.assetSn" class="input" placeholder="资产码" clearable></el-input>
      <el-button type="primary" @click="currentChange(1)" :loading="loading">查询</el-button>
      <el-button type="primary" @click="importBatch = true">导入</el-button>
    </el-row>
    <el-table :data="dataList" border style="width: 100%" stripe>
      <el-table-column align="center" prop="lendOrderCode" label="借出单号"></el-table-column>
      <el-table-column align="center" prop="assetSn" label="资产码"></el-table-column>
      <el-table-column align="center" prop="deliveryTime" label="发货时间"></el-table-column>
      <el-table-column align="center" prop="createUserName" label="创建人"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination background layout="total,prev, pager, next" :page-size="pageSize" :total="total" @current-change="currentChange" :current-page.sync="queryInfo.pageNo"></el-pagination>
    </div>

    <el-dialog title="键盘ATE数据导入" :visible.sync="importBatch" :close-on-click-modal="false" width="800px" :before-close="importClose">
      <ImportComponent template-url="template/keyboardAte.xlsx" upload-url="keyboardAte/importBatch"/>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importClose">关闭</el-button>
      </div>
    </el-dialog>

  </el-card>
</template>

<script>
import ImportComponent from "@/components/ImportComponent.vue";

export default {
  name: "KeyboardAte",
  components: {ImportComponent},
  data() {
    return {
      queryInfo: {
        allotNo: '',
        materialCode: '',
        assetSn: '',
        pageNo: 1
      },
      dataList: [],
      total: 0,
      pageSize: 0,
      importBatch: false,
      loading: false
    }
  },
  created() {
    this.search();
  },
  methods: {
    async search() {
      this.loading = true;
      const {data: res} = await this.$axios.post('keyboardAte/queryList', this.queryInfo);
      this.loading = false;
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }
      this.dataList = res.data.records;
      this.total = res.data.total;
      this.pageSize = res.data.size;
    },
    currentChange(pageNo) {
      this.queryInfo.pageNo = pageNo;
      this.search()
    },
    importClose() {
      this.search();
      this.importBatch = false;
    },
  }
}
</script>

<style scoped>
.input {
  width: 300px;
  margin-right: 10px;
}
</style>